import ReactGA from "react-ga";

import routes from "../routes";

const applicationPaths = routes.map(route => route.path.substring(1));
const EIGHT_LETTERS_OR_NUMBERS = /^[a-zA-Z0-9]{8}$/;
let prevRoute = null;

// Do not track page view if re-navigating to same previously open page
const checkRepeatedPageView = currentRoute => {
  const isRepeated = currentRoute === prevRoute;
  prevRoute = currentRoute;
  return isRepeated;
}

const trackPageView = path => {
  const isCampaignLandingPage = EIGHT_LETTERS_OR_NUMBERS.test(path) && !applicationPaths.includes(path);
  const isVideoLandingPage = path.startsWith("v/");
  const isNextGenLandingPage = path.startsWith("c/");

  if (isCampaignLandingPage) {
    // CLP page views are tracked as /:id
    return ReactGA.pageview("/:id");
  }

  if (isNextGenLandingPage) {
    // Next gen CLP page views are tracked as /:id
    return ReactGA.pageview("/c/:id");
  }

  if (isVideoLandingPage) {
    // Track generic VLP view as /v
    return ReactGA.pageview("/v");
  }

  const nextPage = path;
  return ReactGA.pageview(`/${nextPage}`);
}

const gaPageViewTrackingMiddleware = (store) => (next) => (action) => {
  if (action.type === "@@router/LOCATION_CHANGE") {
    const path = action.payload.pathname.substring(1);
    const isRepeatedPageView = checkRepeatedPageView(path);

    if (!isRepeatedPageView) {
      trackPageView(path);
    }
  }
  return next(action);
};

export default gaPageViewTrackingMiddleware;



// WEBPACK FOOTER //
// ./src/redux/gaPageViewTrackingMiddleware.js